import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Ground from "./components/Ground";
import Iono from "./components/Iono";
import axios from "axios";
import { Utils } from "./Utils";

const TABS = [
  { key: "ground", label: "Ground" },
  { key: "ionosphere", label: "Ionosphere" },
] as const;
type TabKey = (typeof TABS)[number]["key"];

function Station() {
  const { stationId } = useParams();
  const [tab, setTab] = useState<TabKey>("ground");
  const [stationInfo, setStationInfo] = useState<any>(null);

  useEffect(() => {
    axios
      .get(Utils.BACKEND_BASE_URL + "station")
      .then((res) => {
        const info = res.data.find(
          (o: any) => o._id.toLowerCase() === stationId?.toLowerCase()
        );
        setStationInfo(info);
      })
      .catch((err) => console.error("unable to fetch stations", err));
  }, [stationId]);

  return (
    <div className="space-y-6">
      {/* Tabs */}
      <div className="rounded-xl bg-white shadow-sm border border-gray-100 px-4">
        <nav className="flex gap-6">
          {TABS.map((t) => (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              className={`
                py-3 text-sm font-medium uppercase tracking-wide border-b-2 transition
                ${
                  tab === t.key
                    ? "border-brand-300 text-brand-500"
                    : "border-transparent text-gray-400 hover:text-gray-600"
                }
              `}
            >
              {t.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Active tab content */}
      {tab === "ground" && <Ground stationId={stationId} />}
      {tab === "ionosphere" && (
        <Iono stationInfo={stationInfo} stationId={stationId} />
      )}
    </div>
  );
}

export default Station;
